import type { ExperimentalQueries } from '../__types__/ExperimentalQueries';
import { fetchJSON } from '../fetchJSON';
import { MediaType } from '../MediaType';

export const experimentalPromotedSpaces: ExperimentalQueries['experimentalPromotedSpaces'] = (
	_,
	args,
	{ network },
) => {
	const promotedSpacesLimit = (args && args.promotedSpacesLimit) || 10;
	const otherSpacesLimit = (args && args.otherSpacesLimit) || 10;
	const promotedSpaceKey = (args && args.promotedSpaceKey) || '';

	let matchedPromotedSpaces: any;
	return fetchJSON(
		network,
		`/wiki/rest/create-dialog/1.0/spaces?promotedSpacesLimit=${promotedSpacesLimit}&otherSpacesLimit=${otherSpacesLimit}&promotedSpaceKey=${promotedSpaceKey}`,
		{
			method: 'GET',
			headers: {
				'Content-Type': MediaType.JSON,
			},
		},
	)
		.then((json) => {
			matchedPromotedSpaces =
				(json.matchedPromotedSpaces && json.matchedPromotedSpaces.spaces) || [];
			return ((json.promotedSpaces && json.promotedSpaces.spaces) || []).concat(
				(json.otherSpaces && json.otherSpaces.spaces) || [],
			);
		})
		.then((spaces) => ({
			nodes: spaces,
			matchedPromotedSpaces: matchedPromotedSpaces,
			__typename: 'ExperimentalPromotedSpaces',
		}));
};
